<template>
  <!-- 修改设备备注弹出层 -->
     <el-dialog
     :append-to-body="true"
     class="editView"
      :close-on-click-modal="false"
      :visible.sync="editParams.editVisible"
      width="25%">
      <span slot="title" class="title">
        <span>编辑设备昵称</span>
      </span>
       <el-row>
        设备昵称
        <el-tooltip :content="editTips" placement="top" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </el-row>
       <el-row class="mal_t10">
        <el-input maxlength="20" v-model.trim="nickName" placeholder="请输入设备昵称"  size="small"></el-input>
      </el-row>
       <!-- <div class="errMes" v-if="multiParams.showDeiceNumErrMes">{{multiParams.deiceNumErrMes}}</div> -->
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="edit" size="small">确 定</el-button>
        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { deviceEdit } from '@/api/deviceManagement'
export default {
  props: {
    editParams: {
      type: Object
    },
    deviceName: {
      type: String
    },
    productKey: {
      type: String
    },
    placeholderName: {
      type: String
    }
  },
  // ['editVisible', 'deviceId'],
  data () {
    return {
      nickName: '',
      editTips: '支持中文、英文字母、数字和下划线，1~20 个字符'
    }
  },
  created () {
    this.nickName = this.placeholderName
  },
  methods: {
    edit () {
      console.log('changNickName')
      const params = {
        deviceName: this.deviceName,
        productKey: this.productKey,
        nickName: this.nickName
      }
      deviceEdit(params).then(res => {
        res = res.data
        console.log('修改返回：', res)
        res.code === 200
          ? this.$emit('close-view', this.nickName)// (this.dataList[5].value = this.nickName) && (this.editVisible = false)
          : this.$message({
            showClose: true,
            message: '编辑失败，请稍后重试',
            type: 'error'
          })
      })
    },
    closeView () {
      this.$emit('close-view')
      this.nickName = this.placeholderName
    }
  }
}
</script>
<style lang="less" scoped>
 .editView{
    .el-icon-question{
      margin-left: 10px;
      color: rgb(204, 204, 204);
    }
    .title{
      font-size: 16px;
    }
    .mal_t10{
      margin-top: 10px;
    }
  }
</style>
